import {
  params,
  string,
  shape,
  bool,
  arrayOf,
  extend
} from '@thd-nucleus/data-sources';
import { CollectionInfoTabs } from '@thd-olt-component-react/collection-info-tabs';
import { MediaGalleryDesktop } from '@thd-olt-component-react/media-gallery';
import { Breadcrumbs } from '@thd-olt-component-react/breadcrumbs';
import { ListViewPod } from './list-view/ListViewPod';
import { ShopByRoomDataModel } from './shop-by-room/ShopByRoomDataModel';

const mediaGalleryCollection = {
  collection: MediaGalleryDesktop?.dataModel?.collection || {}
};

const collectionProduct = extend({
  itemId: string(),
  dataSources: string(),
  identifiers: shape({
    itemId: string(),
    isSuperSku: bool()
  }),
  info: shape({
    productDepartment: string(),
    sskMin: string(),
    sskMax: string()
  }),
  media: shape({
    images: arrayOf(shape({
      url: string()
    }))
  }),
  reviews: shape({
    ratingsReviews: shape({
      averageRating: string(),
      totalReviews: string()
    })
  })
}, ListViewPod.dataModel.product);

const collectionDs = {
  collection: params({
    collectionId: string().isRequired(),
    storeId: string()
  }).shape({
    collectionId: string(),
    details: shape({
      highlights: arrayOf(string())
    }),
    media: shape({
      images: arrayOf(shape({
        url: string()
      })),
      video: arrayOf(shape({
        type: string()
      }))
    }),
    metadata: shape({
      brandName: string(),
      canonicalUrl: string(),
      collectionDescription: string(),
      name: string(),
      productCount: shape({
        allProducts: string()
      }),
      roomType: string(),
      type: string()
    }),
    products: arrayOf(shape(collectionProduct)),
    taxonomy: shape({
      breadCrumbs: arrayOf(shape({
        label: string(),
        url: string()
      }))
    })
  })
};

export const dataModel = extend(
  Breadcrumbs,
  collectionDs,
  CollectionInfoTabs,
  mediaGalleryCollection,
  ShopByRoomDataModel,
  ListViewPod.dataModel
);
